import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function TopItem(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='top-item-glance-body'
                cssHeadingClass='top-item-glance-heading'
                cssIconClass='icons8-vegetarian-food'
                Heading={t('TopItem')}
                DataPoint1={props.DP1}
                DataPoint2={'<div>' + props.DP2 + '</div>'}
                DataPoint3={props.DP3 + ' ' + t('Sold')}
            ></BaseDataGlance>
        </>
    );
}